import SkillsPane from './SkillsPane';

export default SkillsPane;
export { SkillsPane };
